import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "add-to-a-filled-form",
  courseId: "forms",
  order: 4,
  title: "Add to a form",
  subtitle: "Update a filled form",
  summary:
    "You learned more after the form was filled. Record or upload again and only the new facts are written. What you already have stays.",
  learn: [
    "Add a second round of audio to a completed form",
    "Know what a supplement can and cannot change",
    "Recover if the addition fails",
  ],
  minutes: 2,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "A filled form is not frozen. Each pass of audio is a round, and the AI is told what is already filled and asked to return only what the new recording adds.",
    },
    {
      type: "steps",
      items: [
        "Open the filled form from the template's submissions list.",
        "Click **Add to form**.",
        "Choose **Record Audio** or **Upload Audio**.",
        "Dictate only the new or corrected details, then submit.",
        "When the fill finishes, review the changed fields, which are marked.",
        "Click **Save**, then **Export PDF** again.",
      ],
    },
    {
      type: "callout",
      tone: "note",
      title: "Nothing is erased",
      text: "A supplement never writes an empty answer over a value and never unticks a checkbox. To clear a field, edit it by hand.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "If the addition fails",
      text: "The form stays completed with your previous values and shows a notice. A failed round does not damage the form, so try again.",
    },
    {
      type: "paragraph",
      text: "\"Form outputs\" covers what to choose when you export the updated form.",
    },
  ],
  related: ["fill-a-form-from-audio", "form-outputs"],
};

export default lesson;
